var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1034"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6577 15.16C16.4718 14.5529 14.933 14.0588 13.1471 14.0588C11.3612 14.0588 9.8224 14.5529 8.63652 15.16C8.29209 15.3374 8.00355 15.6068 7.80294 15.9382C7.60233 16.2697 7.49748 16.6502 7.50005 17.0376V19H18.7942V17.0376C18.7942 16.2471 18.3636 15.52 17.6577 15.16ZM13.1471 13.3529C14.7071 13.3529 15.9706 12.0894 15.9706 10.5294V8.05882C15.9706 7.47294 15.4977 7 14.9118 7C14.5448 7 14.22 7.19059 14.0295 7.47294C13.8389 7.19059 13.5142 7 13.1471 7C12.78 7 12.4553 7.19059 12.2648 7.47294C12.0742 7.19059 11.7495 7 11.3824 7C10.7965 7 10.3236 7.47294 10.3236 8.05882V10.5294C10.3236 12.0894 11.5871 13.3529 13.1471 13.3529Z",
    fill: "#FEFEFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC7);
export default __webpack_public_path__ + "static/media/c7.b16542e13a9f2d020618f4467ce95429.svg";
export { ForwardRef as ReactComponent };